module.exports = __webpack_public_path__ + "static/media/our-customer.c8396b64.svg";